import { ShoppingPaymentStatusId } from 'v2/interfaces/shopping';

const INVOICE_STATUS_COLORS: Partial<Record<ShoppingPaymentStatusId, string>> = {
  [ShoppingPaymentStatusId.ABERTA]: 'blue',
  [ShoppingPaymentStatusId.AGUARDANDO_PAGAMENTO]: 'blue',
  [ShoppingPaymentStatusId.EM_PROCESSAMENTO]: 'blue',
  [ShoppingPaymentStatusId.EM_ANALISE]: 'blue',
  [ShoppingPaymentStatusId.PAGA]: 'green',
  [ShoppingPaymentStatusId.NEGOCIADA]: 'green',
  [ShoppingPaymentStatusId.TRIAL]: 'green',
  [ShoppingPaymentStatusId.EM_RECUPERACAO]: 'gold',
  [ShoppingPaymentStatusId.AGENDADA]: 'gold',
  [ShoppingPaymentStatusId.AGUARDANDO_DOCUMENTACAO]: 'gold',
  [ShoppingPaymentStatusId.REEMBOLSO_PARCIAL]: 'orange',
  [ShoppingPaymentStatusId.AGUARDANDO_REEMBOLSO]: 'red',
  [ShoppingPaymentStatusId.REEMBOLSADO]: 'red',
  [ShoppingPaymentStatusId.CANCELADA]: 'red',
  [ShoppingPaymentStatusId.RECUSADO]: 'red',
  [ShoppingPaymentStatusId.INADIMPLENTE]: 'red'
};

export function getInvoiceStatusColor(paymentStatusId: number): string | undefined {
  return INVOICE_STATUS_COLORS[paymentStatusId as ShoppingPaymentStatusId];
}
